export enum StreamAnswerGenerationTypes {
	LUMINA = 'LUMINA',
	STANDARD = 'STANDARD',
}
